import { useQuery } from '@tanstack/react-query';
import { DEFAULT_KEY_VALUES_QUERY_KEY } from './keyValues.constants';
import { fetchKeyValues } from './keyValues.requests';
import type { GetKeyValuesParams, KeyValues } from './keyValues.types';

export const useKeyValues = <T>(params: GetKeyValuesParams) =>
  useQuery<KeyValues<T>>({
    queryKey: [DEFAULT_KEY_VALUES_QUERY_KEY, params.key],
    queryFn: () => fetchKeyValues<T>(params),
  });
